import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDatePipe implements PipeTransform {

  // We inject DatePipe to use its built-in formatting power
  constructor(private datePipe: DatePipe) {}

  transform(value: any): any {
    if (!value || typeof value !== 'string') {
      return value;
    }

    // Regex to check for YYYY-MM-DD format
    const dateRegex = /^\d{4}-\d{2}-\d{2}/;
    
    if (dateRegex.test(value)) {
      const date = new Date(value);
      
      // Check if it's a valid date object
      if (!isNaN(date.getTime())) {
        return this.datePipe.transform(date, 'MM/dd/yyyy');
      }
    }

    return value;
  }
}